module.exports = __webpack_public_path__ + "assets/img/1506_02.jpg?99ef6325877740eb563e2ed3625b9c78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1506_02.jpg
// module id = 1087
// module chunks = 0